import React from 'react';
import { IDetailLoctaion } from '../../../types';
import DetailsCribs from './DetailsCribs';
import InfiniteScroll from 'react-infinite-scroll-component';
import Loader from '../../../global/ui/Loader';

const LocationCribSheet: React.FC<IDetailLoctaion> = ({ cribsEnteries, updateCrib, deleteCrib, fetchMoreData, nextUrl, canViewLocation, role }) => {
    return (
        <InfiniteScroll
            dataLength={cribsEnteries?.length as never}
            next={fetchMoreData as never}
            hasMore={nextUrl ? true : false}
            loader={<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}><Loader imgStyle={{ width: '40px', height: '40px' }} /></div>}
            scrollableTarget="scrollableId"
        >
            <DetailsCribs
                onDelete={deleteCrib}
                onEdit={updateCrib}
                allData={canViewLocation ? cribsEnteries as never : []}
                role={role}
            />
        </InfiniteScroll>
    );
};

export default LocationCribSheet;